import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { facesNumberEnum } from "config/enum";

export default function DeviceGeneral({
  deviceType,
  payload,
  setPayload,
  levelNumber,
  setLevelNumber,
  facesNumber,
  setFacesNumber,
  pylon,
  setPylon,
  location,
  setLocation,
  configuration,
  setConfiguration,
}) {
  useEffect(() => {
    if (deviceType === "Chaise") {
      setFacesNumber(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceType]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        {deviceType && !deviceType.includes("Port") && (
          <Grid item xs={4}>
            <FormField
              inputProps={{ maxLength: 255 }}
              value={payload}
              onChange={(event) => setPayload(event.target.value)}
              variant="standard"
              type="number"
              label="Charge utile (en kg)"
            />
          </Grid>
        )}
        {deviceType && !deviceType.includes("Port") && (
          <Grid item xs={4}>
            <FormField
              inputProps={{ maxLength: 255 }}
              value={levelNumber}
              onChange={(event) => setLevelNumber(event.target.value)}
              variant="standard"
              type="number"
              label="Nombre de niveau"
            />
          </Grid>
        )}
        {deviceType && !deviceType.includes("Port") && (
          <Grid item xs={4}>
            <Autocomplete
              options={facesNumberEnum}
              value={facesNumber}
              onChange={(event, newFacesNumber) => {
                setFacesNumber(newFacesNumber);
              }}
              renderInput={(params) => (
                <MDInput {...params} label="Nombre de face de service" variant="standard" />
              )}
            />
          </Grid>
        )}
        {deviceType && !deviceType.includes("Port") && deviceType !== "Chaise" && (
          <Grid item xs={6}>
            <Autocomplete
              options={["Avec", "Sans"]}
              value={pylon}
              onChange={(event, newPylon) => {
                setPylon(newPylon);
              }}
              renderInput={(params) => <MDInput {...params} label="Pylône" variant="standard" />}
            />
          </Grid>
        )}
        {deviceType && deviceType === "Chaise" && (
          <Grid item xs={6}>
            <Autocomplete
              options={["Courbe", "Droite"]}
              value={configuration}
              onChange={(event, newConfig) => {
                setConfiguration(newConfig);
              }}
              renderInput={(params) => (
                <MDInput {...params} label="Configuration" variant="standard" />
              )}
            />
          </Grid>
        )}
        {deviceType && !deviceType.includes("Port") && (
          <Grid item xs={6}>
            <Autocomplete
              options={["Intérieur", "Extérieur"]}
              value={location}
              onChange={(event, newLocation) => {
                setLocation(newLocation);
              }}
              renderInput={(params) => <MDInput {...params} label="Position" variant="standard" />}
            />
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
}
